import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { v4 } from 'uuid';
import { updateCompany } from '../../../redux/actions/company_action';
import logoLaPieza from '../../../system/access/images/icon.png';
import { palette } from '../../../system/styles/styles';
import { storage } from '../../../system/model/firebase/firebase';

const FormMain = styled.form`
  width: 95%;
  height: 80vh;
  background-color: ${palette.white};
  border-radius: 10px;
  padding: 10px 15px;
  box-shadow: ${palette.lightBS};
  display: grid;
  grid-template-rows: 25vh 55vh;
  .containerMain {
    height: 100%;
    display: grid;
    grid-template-columns: 200px calc(100% - 220px);
    justify-items: center;
    align-items: center;
    .containerImg {
      display: flex;
      flex-direction: column;
      justify-items: center;
      align-items: center;
      label {
        cursor: pointer;
      }
      img {
        width: 150px;
        height: 150px;
        object-fit: cover;
        object-position: center;
        border-radius: 10px;
      }
      input {
        display: none;
      }
    }
    .containerForm {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 10px;
      label {
        font-family: ${palette.nereg};
        font-size: 18px;
        font-weight: 400;
        letter-spacing: 0.5px;
        color: ${palette.grayNew};
        &:after {
          content: ':';
        }
      }
      input {
        font-family: ${palette.nereg};
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0.5px;
        border: 1.5px solid ${palette.grayNew};
        border-radius: 10px;
        padding: 7px 10px;
        box-shadow: none;
      }
    }
  }
  .containerFormMain {
    display: grid;
    grid-template-columns: 50% 50%;
    padding: 30px;
    article {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 90%;
    }
    label {
      font-family: ${palette.nereg};
      font-size: 18px;
      font-weight: 400;
      letter-spacing: 0.5px;
      color: ${palette.grayNew};
      &:after {
        content: ':';
      }
    }
    input {
      font-family: ${palette.nereg};
      font-size: 16px;
      font-weight: 400;
      letter-spacing: 0.5px;
      border: 1.5px solid ${palette.grayNew};
      border-radius: 10px;
      padding: 7px 10px;
      box-shadow: none;
      width: 94%;
    }
    textarea {
      font-family: ${palette.nereg};
      font-size: 16px;
      font-weight: 400;
      letter-spacing: 0.5px;
      border: 1.5px solid ${palette.grayNew};
      border-radius: 10px;
      padding: 7px 10px;
      box-shadow: none;
      min-width: 95%;
      max-width: 95%;
      max-height: 17%;
      min-height: 17%;
    }
    button {
      background-color: ${palette.blue};
      color: ${palette.white};
      font-family: ${palette.nereg};
      font-size: 18px;
      font-weight: 400;
      letter-spacing: 0.5px;
      border: none;
      width: 100%;
      border-radius: 10px;
      cursor: pointer;
      padding: 5px;
    }
  }
`;

const ContainerCompany = (props) => {
  const { company } = props;
  const { platform, auth } = useSelector((state) => state);
  const { t } = useTranslation(['admin']);
  const dispatch = useDispatch();
  const [state, setState] = React.useState({
    companyLogo: logoLaPieza,
    companyName: '',
    companyEmail: '',
    companyLinkedin: '',
    companyFacebook: '',
    companyTwitter: '',
    locationName: '',
    companyPhone: '',
    companyWebsite: '',
    companyAbout: '',
    data: '',
  });

  React.useEffect(() => {
    const {
      companyLogo = logoLaPieza,
      companyName = '',
      companyEmail = '',
      companyLinkedin = '',
      companyFacebook = '',
      companyTwitter = '',
      locationName = '',
      companyPhone = '',
      companyWebsite = '',
      companyAbout = '',
      data = '',
    } = company;
    setState((prev) => ({
      ...prev,
      companyLogo,
      companyName,
      companyEmail,
      companyLinkedin,
      companyFacebook,
      companyTwitter,
      locationName,
      companyPhone,
      companyWebsite,
      companyAbout,
      data,
    }));
  }, [company]);

  const onChangeInput = ({ target }) => {
    const { value, name } = target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const onSave = () => {
    dispatch(updateCompany({
      ...state,
      active: true
    }));
  };

  const updloadImage = async (even) => {
    const name = `company/${platform?.platformName}/profiles/${auth?.uid}/userProfile/${v4()}`;
    const updaload = storage.ref(name).put(even?.target?.files[0]);
    updaload.then(() => {
      updaload.snapshot.ref.getDownloadURL().then((url) => {
        setState((prevState) => ({ ...prevState, companyLogo: url }));
      });
    });
  };
  return (
    <FormMain>
      <section className="containerMain">
        <article className="containerImg">
          <label htmlFor="logo">
            <img alt="Logo" src={state.companyLogo} />
          </label>
          <input id="logo" type="file" onChange={updloadImage} />
        </article>
        <article className="containerForm">
          <label>{t('labelCompanyName')}</label>
          <input type="text" name="companyName" value={state.companyName} onChange={onChangeInput} />
          <label>{t('labelCompanyEmail')}</label>
          <input type="text" name="companyEmail" value={state.companyEmail} onChange={onChangeInput} />
        </article>
      </section>
      <section className="containerFormMain">
        <article>
          <label>{t('labelSiteWeb')}</label>
          <input type="text" name="companyWebsite" value={state.companyWebsite} onChange={onChangeInput} />
          <label>{t('labelCompanyPhone')}</label>
          <input type="text" name="companyPhone" value={state.companyPhone} onChange={onChangeInput} />
          <label>{t('labelCompanyLocation')}</label>
          <input type="text" name="locationName" value={state.locationName} onChange={onChangeInput} />
          <label>Facebook</label>
          <input type="text" name="companyFacebook" value={state.companyFacebook} onChange={onChangeInput} />
          <label>Twitter</label>
          <input type="text" name="companyTwitter" value={state.companyTwitter} onChange={onChangeInput} />
        </article>
        <article>
          <label>LinkedIn</label>
          <input type="text" name="companyLinkedin" value={state.companyLinkedin} onChange={onChangeInput} />
          <label>{t('labelCompanyDescription')}</label>
          {/* <textarea name="companyAbout" value={state.companyAbout} onChange={onChangeInput} />  */}
          {/* <label>{t('labelCompanyData')}</label> */}
          <textarea name="data" value={state.data} onChange={onChangeInput} />
          <button type="button" onClick={onSave}>
            {t('publish')}
          </button>
        </article>
      </section>
    </FormMain>
  );
};

ContainerCompany.propTypes = {
  company: PropTypes.objectOf(PropTypes.any),
};

ContainerCompany.defaultProps = {
  company: {},
};

export default ContainerCompany;
